"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolePermission = exports.Role = void 0;
var Role;
(function (Role) {
    Role["Operator"] = "operator";
    Role["SuperAdmin"] = "superadmin";
    Role["Operations"] = "Operations";
    Role["FinancialTeam"] = "Financial Team";
    Role["MarketingTeam"] = "Marketing Team";
    Role["SportsbookManager"] = "Sportsbook Manager";
    Role["CasinoManager"] = "Casino Manager";
    Role["SupportAndCRM"] = "Support and CRM";
    Role["BOAdmin"] = "BO Admin";
    Role["RestrictedOperations"] = "Restricted Operations";
})(Role || (exports.Role = Role = {}));
var RolePermission;
(function (RolePermission) {
    RolePermission["CreateRole"] = "CreateRole";
    RolePermission["CreateAdmin"] = "CreateAdmin";
})(RolePermission || (exports.RolePermission = RolePermission = {}));
//# sourceMappingURL=role.js.map